import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import DataTable from '../../../../components/DataTable/DataTable';
import EmptyTableSection from '../../../../components/DataTable/EmptyTableSection';
import { SRT_STATES } from '../../consts/states';
import { getDate } from '../../../../utils/common';
import { renderStateChipSRT } from '../../RGRL/components/StateChipSRT';
import { TEST_IDS } from '../../consts/testIds';
import { columnTitles, columnWidths } from '../consts/table';
import {
    getVisitTypeDescription,
    getVisitTypeDescriptions,
    hasMultipleVisitTypes
} from '../utils/visitTypes';

interface VisitsTableProps {
    items: any;
    handleItemCheck: (item: any) => void;
    selectedVisits: any[];
    translate: (key: string) => string;
    handleRowClick: any;
    selected: any;
    selectedItemFromAction: any;
    menuOpen: any;
    filters: any;
    setFilters: any;
    isFetching: boolean;
    handleClickAction: any;
    selectedVisitType?: any;
    isSelectAllEnabled: boolean;
    isAllSelected: boolean;
    onSelectAllCheckPress: (checked: boolean) => void;
}

const VisitTypeCell = ({ item, selectedVisitType }: { item: any; selectedVisitType?: any }) => {
    if (!hasMultipleVisitTypes(item))
        return <>{getVisitTypeDescription(item, selectedVisitType)}</>;

    const visitTypes = getVisitTypeDescriptions(item);

    return (
        <Tooltip
            enterDelay={200}
            arrow
            title={
                <Box sx={{ minWidth: 220 }}>
                    {visitTypes.map((visitType) => (
                        <Typography key={visitType} variant="body2" sx={{ color: '#fff' }}>
                            {visitType}
                        </Typography>
                    ))}
                </Box>
            }
        >
            <Box component="span" sx={{ cursor: 'default' }}>
                {'MÚLTIPLE'}
            </Box>
        </Tooltip>
    );
};

const VisitsTable = ({
    items,
    handleItemCheck,
    selectedVisits,
    translate,
    handleRowClick,
    selected,
    selectedItemFromAction,
    menuOpen,
    isFetching,
    filters,
    setFilters,
    handleClickAction,
    selectedVisitType,
    isSelectAllEnabled,
    isAllSelected,
    onSelectAllCheckPress
}: VisitsTableProps) => {
    return (
        <>
            {items?.length === 0 ? (
                <EmptyTableSection title={translate('table.noData.title')} />
            ) : (
                <DataTable
                    testID={TEST_IDS.table.visits.id}
                    columnTitles={columnTitles({
                        translate,
                        isSelectAllEnabled,
                        checked: isAllSelected,
                        onSelectAllCheckPress
                    })}
                    columnWidths={columnWidths}
                    onSelectRow={handleRowClick}
                    selected={selected}
                    selectedItemFromAction={selectedItemFromAction}
                    menuOpen={menuOpen}
                    items={items}
                    loading={isFetching}
                    filters={filters}
                    setFilters={setFilters}
                    isFetching={isFetching}
                    headers={[
                        {
                            type: 'data',
                            upperLabel: (item: any) => (
                                <Checkbox
                                    checked={selectedVisits.some(
                                        (selectedVisit: any) => selectedVisit.id === item.id
                                    )}
                                    disabled={item?.estadoSRT === SRT_STATES.ERROR}
                                    onChange={() => handleItemCheck(item)}
                                />
                            )
                        },
                        {
                            type: 'data',
                            maxWidth: '200px',
                            upperLabel: (item: any) =>
                                item?.establecimiento?.organismo?.contrato?.cuit || '-'
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) =>
                                item?.establecimiento?.organismo?.contrato?.nombre || '-'
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            onClickColumnTitleSortName: 'codigoSRT',
                            upperLabel: (item: any) =>
                                `${item?.establecimiento?.numero} - ${item?.establecimiento?.nombre}`
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) => (
                                <VisitTypeCell item={item} selectedVisitType={selectedVisitType} />
                            )
                        },
                        {
                            type: 'data',
                            maxWidth: '250px',
                            upperLabel: (item: any) => getDate(item?.fecha) || '-'
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) =>
                                renderStateChipSRT(item?.estadoSRT, translate)
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) =>
                                item?.archivos[0]?.fechaGeneracion
                                    ? getDate(item.archivos[0].fechaGeneracion)
                                    : '-'
                        },
                        {
                            type: 'action',
                            onClick: handleClickAction
                        }
                    ]}
                />
            )}
        </>
    );
};

export { VisitsTable };
